import React, { useState } from 'react';
import { FaChevronDown } from "react-icons/fa";
import { Link, useLocation } from 'react-router-dom';
import assetUrl from '../../services/assetUrl';

const MenuItems = (props) => {
    const { parentMenu } = props;
    const location = useLocation();

    // Active indicators for primary navigation categories
    const isAboutActive = parentMenu === 'about' || location.pathname === '/about-nagarjuna';
    const isAcademicsActive = parentMenu === 'academics' || [
        '/departments', '/department', '/idealab', '/autonomous-regulations',
        '/examination', '/nisp-policy', '/iic', '/model-question-papers', '/b-tech-model-papers',
        '/m-tech-model-papers', '/mba-model-papers', '/mbai-model-papers', '/mca-model-papers'
    ].some(path => location.pathname.startsWith(path));
    
    const isStudentLifeActive = parentMenu === 'student-life' || parentMenu === 'facilities' || [
        '/hostel', '/hostels', '/alumni', '/ncc', '/gallery'
    ].includes(location.pathname);
    
    const isIqacActive = parentMenu === 'iqac' || parentMenu === 'accreditation' || parentMenu === 'credentials' || [
        '/iqac', '/monthly-reports', '/audit-reports', '/approvals-and-disclosure'
    ].includes(location.pathname);

    // Mobile drawer accordion toggle states
    const [aboutOpen, setAboutOpen] = useState(false);
    const [academicsOpen, setAcademicsOpen] = useState(false);
    const [departmentsSubOpen, setDepartmentsSubOpen] = useState(false);
    const [studentLifeOpen, setStudentLifeOpen] = useState(false);
    const [iqacOpen, setIqacOpen] = useState(false);

    const toggleMobileMenu = (menu) => {
        if (menu === 'about') {
            setAboutOpen(prev => !prev);
            setAcademicsOpen(false);
            setStudentLifeOpen(false);
            setIqacOpen(false);
            return;
        }
        if (menu === 'academics') {
            setAcademicsOpen(prev => !prev);
            if (academicsOpen) setDepartmentsSubOpen(false);
            setAboutOpen(false);
            setStudentLifeOpen(false);
            setIqacOpen(false);
            return;
        }
        if (menu === 'departmentsSub') {
            setDepartmentsSubOpen(prev => !prev);
            return;
        }
        if (menu === 'studentLife') {
            setStudentLifeOpen(prev => !prev);
            setAboutOpen(false);
            setAcademicsOpen(false);
            setIqacOpen(false);
            return;
        }
        if (menu === 'iqac') {
            setIqacOpen(prev => !prev);
            setAboutOpen(false);
            setAcademicsOpen(false);
            setStudentLifeOpen(false);
            return;
        }
    };

    // Smooth scroll helper for on-page hash navigation
    const handleHashClick = (hash) => {
        if (location.pathname === '/about-nagarjuna') {
            const el = document.querySelector(hash);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <>
            {/* 1. Home */}
            <li className={location.pathname === '/' ? 'menu-active' : ''}>
                <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                    Home
                </Link>
            </li>

            {/* 2. About Us */}
            <li className={isAboutActive ? 'has-sub menu-active' : 'has-sub'}>
                <Link
                    to="#"
                    className={aboutOpen ? "hash menu-active" : "hash"}
                    onClick={(e) => { e.preventDefault(); toggleMobileMenu('about'); }}
                >
                    About Us
                    <span className="arrow"></span>
                </Link>
                <ul className={aboutOpen ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li>
                        <Link to="/about-nagarjuna#legacy" onClick={() => handleHashClick('#legacy')}>
                            About NGI
                        </Link>
                    </li>
                    <li>
                        <Link to="/about-nagarjuna#management" onClick={() => handleHashClick('#management')}>
                            Management Members
                        </Link>
                    </li>
                    <li>
                        <Link to="/about-nagarjuna#vision-mission" onClick={() => handleHashClick('#vision-mission')}>
                            Vision &amp; Mission
                        </Link>
                    </li>
                    <li>
                        <Link to="/about-nagarjuna#principal" onClick={() => handleHashClick('#principal')}>
                            Principal's Message
                        </Link>
                    </li>
                    <li>
                        <Link to="/about-nagarjuna#campuses" onClick={() => handleHashClick('#campuses')}>
                            Our Campuses
                        </Link>
                    </li>
                </ul>
            </li>

            {/* 3. Academics */}
            <li className={isAcademicsActive ? 'has-sub menu-active' : 'has-sub'}>
                <Link
                    to="#"
                    className={academicsOpen ? "hash menu-active" : "hash"}
                    onClick={(e) => { e.preventDefault(); toggleMobileMenu('academics'); }}
                >
                    Academics
                    <span className="arrow"></span>
                </Link>
                <ul className={academicsOpen ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname.startsWith('/department') ? 'has-sub menu-active' : 'has-sub'}>
                        <Link
                            to="/departments"
                            className={departmentsSubOpen ? "hash menu-active" : "hash"}
                            onClick={(e) => {
                                // On mobile, allow tapping chevron to expand sub-menu
                                if (window.innerWidth < 1200) {
                                    e.preventDefault();
                                    toggleMobileMenu('departmentsSub');
                                }
                            }}
                        >
                            Departments
                            <FaChevronDown className={`arrow-icon arrow arrow-icon-new ${departmentsSubOpen ? 'rotate' : ''}`} />
                        </Link>
                        <ul className={departmentsSubOpen ? "sub-menu sub-menu-open" : "sub-menu"}>
                            <li>
                                <Link to="/departments?tab=ug">UG</Link>
                            </li>
                            <li>
                                <Link to="/departments?tab=pg">PG</Link>
                            </li>
                            <li>
                                <Link to="/departments?tab=science">Basic Science</Link>
                            </li>
                            <li>
                                <Link to="/departments">View All</Link>
                            </li>
                        </ul>
                    </li>
                    <li className={location.pathname === '/idealab' ? 'menu-active' : ''}>
                        <Link to="/idealab">IDEA Lab</Link>
                    </li>
                    <li className={location.pathname === '/autonomous-regulations' ? 'menu-active' : ''}>
                        <Link to="/autonomous-regulations">Autonomous Regulations</Link>
                    </li>
                    <li className={location.pathname === '/examination' ? 'menu-active' : ''}>
                        <Link to="/examination">Exams</Link>
                    </li>
                    <li className={location.pathname === '/nisp-policy' ? 'menu-active' : ''}>
                        <Link to="/nisp-policy">NISP Policy</Link>
                    </li>
                    <li className={location.pathname === '/iic' ? 'menu-active' : ''}>
                        <Link to="/iic">IIC</Link>
                    </li>
                </ul>
            </li>

            {/* 4. Student Life */}
            <li className={isStudentLifeActive ? 'has-sub menu-active' : 'has-sub'}>
                <Link
                    to="#"
                    className={studentLifeOpen ? "hash menu-active" : "hash"}
                    onClick={(e) => { e.preventDefault(); toggleMobileMenu('studentLife'); }}
                >
                    Student Life
                    <span className="arrow"></span>
                </Link>
                <ul className={studentLifeOpen ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname === '/hostel' || location.pathname === '/hostels' ? 'menu-active' : ''}>
                        <Link to="/hostels">Hostels</Link>
                    </li>
                    <li>
                        <a href={assetUrl('/footer/NCET_Bus_Route_Details.pdf')} target="_blank" rel="noopener noreferrer">
                            Transport
                        </a>
                    </li>
                    <li className={location.pathname === '/alumni' ? 'menu-active' : ''}>
                        <Link to="/alumni">Alumni</Link>
                    </li>
                    <li className={location.pathname === '/ncc' ? 'menu-active' : ''}>
                        <Link to="/ncc">NCC</Link>
                    </li>
                    <li className={location.pathname === '/gallery' ? 'menu-active' : ''}>
                        <Link to="/gallery">Gallery</Link>
                    </li>
                </ul>
            </li>

            {/* 5. Placements */}
            <li className={location.pathname === '/placements' ? 'menu-active' : ''}>
                <Link to="/placements" className={location.pathname === '/placements' ? 'active' : ''}>
                    Placements
                </Link>
            </li>

            {/* 6. Research (moved after Placements) */}
            <li className={location.pathname === '/research' ? 'menu-active' : ''}>
                <Link to="/research" className={location.pathname === '/research' ? 'active' : ''}>
                    Research
                </Link>
            </li>

            {/* 7. IQAC (renamed from Documents) */}
            <li className={isIqacActive ? 'has-sub menu-active' : 'has-sub'}>
                <Link
                    to="#"
                    className={iqacOpen ? "hash menu-active" : "hash"}
                    onClick={(e) => { e.preventDefault(); toggleMobileMenu('iqac'); }}
                >
                    IQAC
                    <span className="arrow"></span>
                </Link>
                <ul className={iqacOpen ? "sub-menu sub-menu-open" : "sub-menu"}>
                    <li className={location.pathname === '/iqac' ? 'menu-active' : ''}>
                        <Link to="/iqac">IQAC</Link>
                    </li>
                    <li className={location.pathname === '/monthly-reports' ? 'menu-active' : ''}>
                        <Link to="/monthly-reports">Monthly Reports</Link>
                    </li>
                    <li className={location.pathname === '/audit-reports' ? 'menu-active' : ''}>
                        <Link to="/audit-reports">Audit Reports</Link>
                    </li>
                    <li className={location.pathname === '/nisp-policy' ? 'menu-active' : ''}>
                        <Link to="/nisp-policy">NISP Policy</Link>
                    </li>
                    <li className={location.pathname === '/approvals-and-disclosure' ? 'menu-active' : ''}>
                        <Link to="/approvals-and-disclosure">Mandatory disclosure</Link>
                    </li>
                </ul>
            </li>

            {/* 8. Admission */}
            <li className={location.pathname === '/admission-process' ? 'menu-active' : ''}>
                <Link to="/admission-process" className={location.pathname === '/admission-process' ? 'active' : ''}>
                    Admission
                </Link>
            </li>
        </>
    );
};

export default MenuItems;
